document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.js-header');
	if (!header) return;

	const mq = window.matchMedia('(max-width: 768px)');
	let ticking = false;

	const update = () => {
		header.classList.toggle('is-scrolled', mq.matches && window.scrollY > 0);
		ticking = false;
	};

	const onScroll = () => {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	};

	window.addEventListener('scroll', onScroll, { passive: true });
	mq.addEventListener('change', update);

	update();
});
